var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { staticClass: "m-0 mb-6" }, [
      _vm._v(_vm._s(_vm.$l10n.__("Rapports")))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "white-bkg p-5 b-1 br" },
      [
        _c("simple-search-list", {
          attrs: {
            datas: _vm.reports,
            columns: _vm.columns,
            placeholder: _vm.$t.__(
              "pages.reports.ReportsListing.search_report"
            ),
            rowNumberLabel: _vm.$t.__("common.labels.reports"),
            cumulioAuth: _vm.cumulioAuth
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }